var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Introduce",class:_vm.Introduce.class},[_c('div',{staticClass:"main"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.Introduce.title))]),_vm._v(" "),_vm._l((_vm.Introduce.contents),function(item,index){return _c('p',{staticClass:"text"},[_vm._v(_vm._s(item))])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ef4b273","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/About_Us/Introduce.vue
// module id = null
// module chunks = 